<template>
    <span>
        <a 
            @click.stop.prevent="$emit('toggled-state'); state = !state;" 
            class="toggle-detail"
            href>
                <span v-if="state">{{labels[1175]}}</span>
                <span v-if="!state">{{labels[1179]}}</span>
                <span 
                    class="ui-icon inlineblock v-align-middle" 
                    :class="{'ui-icon-triangle-1-s': state, 'ui-icon-triangle-1-n': !state}" />
        </a>
        <div v-show="!state"><slot></slot></div>
    </span>
</template>
<script>
import useCMS from '../../shared/composables/useCMS';
import { ref } from '@vue/composition-api';
export default {
    name: 'toggleDetail',
    props: {
        initialState: Boolean
    },
    setup: function(props){
        const { labels } = useCMS();
        var state = ref(props.initialState);

        return { labels, state };
    },
    emits: ['toggled-state']
}
</script>